<template>
	<div v-if="showcontrol">
		<!-- 弹窗 -->
		<!-- :title="dialTitle" -->
		<!-- v-if="Mxloader" -->
		<el-dialog v-dialogDrag :visible.sync="dialogVisible" width="85%" ref="sel_el" @close="close"
			style="z-index: 1 !important;">
			<div @dblclick="copyid" style="width: 100%;height: 10px;"></div>
			<!-- :processDisabled="processdisabledd" -->
			<v-form-render :form-json="dialFormJson" :form-data="dialFormData" :option-data="dialOptionData"
				ref="vFormRefdilog">
			</v-form-render>
		</el-dialog>
		<!-- 详情页 -->
		<!-- :title="dialTitle"  -->
		<el-dialog v-dialogDrag v-if="loader" :visible.sync="detailsdialogVisible" width="85%" ref="details" @close="close">
			<div @dblclick="copyid" style="width: 100%;height: 10px;"></div>
			<detailspage :typestring="'details'" :newformdata="detailsFormdata" :filterData="filterData"
				@OpenPrintPreview="OpenPrintPreview" @OpenPrintPage="OpenPrintPage">
			</detailspage>
		</el-dialog>

		<!-- 打印 -->
		<el-dialog v-dialogDrag :title="dialTitle" :visible.sync="pritersdialogVisible" width="85%" ref="details">
			<printPage ref="PriterRef" class="body" :fromid="fromid"></printPage>
		</el-dialog>

		<v-form-render v-if="showcontrol" :form-json="formJson" :globalDsv="globalDsv" :form-data="formData"
			:option-data="optionData" ref="vFormRef">
		</v-form-render>
		<!-- "可拖拽元素" 容器 -->
		<!-- <div title="这是方式2,仅显示自定义元素的标题" class="hiprintEpContainer2"></div> -->
		<!-- 这是 "多面板" 容器 点击切换面板 -->
		<!-- <div class="hiprint-printPagination"></div> -->
		<!-- 这是 "拖拽设计器" 容器 -->
		<!-- <div id="hiprint-printTemplate"></div> -->
		<!-- 这是 "元素参数设置" 容器 -->
		<div id="PrintElementOptionSetting"></div>
		<el-dialog title="选择打印机" :visible.sync="PritndialogVisible" width="30%">
			<el-select v-model="printselectvalue" placeholder="请选择">
				<el-option v-for="item in printselect" :key="item.name" :label="item.name" :value="item.name">
				</el-option>
			</el-select>
			<span slot="footer" class="dialog-footer">
				<el-button @click="PritndialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="Pritenasd(fromid, fromobj, fromotype)">打印</el-button>
			</span>
		</el-dialog>


		<ImgVue ref="ImgVue"></ImgVue>
	</div>
</template>
<script>
import * as forms from '@/api/forms'
import * as getMaoToken from '@/utils/auth'
import detailspage from '../flowinstances/detail.vue'
import printPage from '../dlsvprint/index.vue'
import * as sysRpts from '@/views/dlsvprint/api/sysRpts'
import * as apiFlowinstances from '@/api/flowinstances'
import { io } from "socket.io-client";
import ImgVue from "./ImgVue.vue";
import Bus from "@/utils/EventBus";
import EventBus from "@/utils/EventBus";
import { autoConnect, disAutoConnect, hiprint, defaultElementTypeProvider } from "@sv-print/hiprint";

export default {
	components: { detailspage, printPage, ImgVue },
	inject: ['reload'],
	data() {
		return {
			formJson: {},
			showcontrol: true,
			formData: {
				'goodsId': '',
				"saleManId": ""
			},
			optionData: {},
			Mxloader: true,
			dialogVisible: false, //弹窗显示
			PritndialogVisible: false,
			dialFormJson: {
				"widgetList": [],
				"formConfig": {
					"modelName": "formData",
					"refName": "vForm",
					"rulesName": "rules",
					"labelWidth": 80,
					"labelPosition": "left",
					"size": "",
					"labelAlign": "label-left-align",
					"cssCode": "",
					"customClass": "",
					"functions": "",
					"layoutType": "PC",
					"onFormCreated": "",
					"onFormMounted": "",
					"onFormDataChange": "",
					"onFormValidate": ""
				}
			}, //弹窗渲染数据
			dialFormData: {}, //弹窗表单数据
			dialOptionData: {}, //弹窗选择数据
			loader: false,
			processdisabledd: false,
			detailsdialogVisible: false,
			pritersdialogVisible: false,
			detailsFormdata: null,
			filterData: {},
			thistype: '',
			dialTitle: "弹出框", //更新20230707代码
			globalDsv: {
				x_token: getMaoToken.getToken(),
				api_url: process.env.VUE_APP_BASE_API,
				img_url: process.env.VUE_APP_BASE_IMG_UR,
				sel_formdata: {}, //formdata
				sel_mainds: [], //获取弹出框单据主数据集的值
				sel_djmxds: [], //获取弹出框表格明细数据的值

			},
			myglobalDsv: {
				x_token: getMaoToken.getToken(),
				api_url: process.env.VUE_APP_BASE_API,
				img_url: process.env.VUE_APP_BASE_IMG_UR,
				sel_formdata: {}, //formdata
				sel_mainds: [], //获取弹出框单据主数据集的值
				sel_djmxds: [], //获取弹出框表格明细数据的值

			},
			renderObject1: {},
			renderObject2: {},
			updateObj: '',
			printFrom: null,
			hiprintTemplate: null,
			printselect: '',
			fromid: '',
			fromobj: '',
			fromotype: '',
			FaName: '',
			printselectvalue: '',
			xmx: false,
			reloadMx: false,
			pathlog: '',
			cptyip: ''
		}

	},
	watch: {
		$route() {

			if (this.$route.meta.keepAlive == false) {
				this.po()
				this.$route.meta.keepAlive = true
			}
		}
	},
	created() {
		hiprint.init({
			providers: [new defaultElementTypeProvider()],
		});


	},



	async mounted() {
		// 等待 vform 异步加载完成后再渲染表单
		if (window.__vformReady) {
			await window.__vformReady
		}

		EventBus.$on("Nrefresh", (row) => {
			this.po()
		});
		// console.log('Nolode', JSON.parse(window.localStorage.getItem('Nolode')));
		if (!this.$route.meta.formId) {
			// return;
		} else {
			let now = false
			if (JSON.parse(window.localStorage.getItem('Nolode'))) {
				now = JSON.parse(window.localStorage.getItem('Nolode'))
			}
			if (now == true) {
				this.loaderTable()
			} else {
				this.loaderTable()
			}
			window.localStorage.setItem('Nolode', false)
		}

	},
	methods: {
		po() {
			// this.showcontrol = false
			// setTimeout(() => {
			// 	this.showcontrol = true
			// }, 100);
			this.reload()
		},
		refresh() {
			this.dialogVisible = false
			this.showcontrol = false
			this.detailsdialogVisible = false
			setTimeout(() => {
				this.showcontrol = true
			}, 1000);
			// this.reload()
		},
		submitForm(res) {
			if (res) {
				if (this.$refs.vFormRef.globalDsv.okFun) {
					this.$refs.vFormRef.globalDsv.okFun(res);
				}
			}
			else {
				if (this.$refs.vFormRef.globalDsv.okFun) {
					this.$refs.vFormRef.globalDsv.okFun(null);
				}
			}
			this.dialogVisible = false;
		},
		submitTable(res) {
			if (res) {
				if (this.$refs.vFormRef.globalDsv.okFun) {
					this.$refs.vFormRef.globalDsv.okFun(res);
				}
			}
			else {
				if (this.$refs.vFormRef.globalDsv.okFun) {
					this.$refs.vFormRef.globalDsv.okFun(null);
				}
			}
			this.dialogVisible = false;
			if (this.$refs.vFormRef.globalDsv.filterData) {
				this.$refs.vFormRef.globalDsv.filterData = null;
			}
		},
		fetchData(id) {
			return forms
				.get({
					"id": id
				})

		},
		show(event) {
			// 此处可以使用判断条件控制是否需要阻止右键
			event.preventDefault();
		},
		//选择器中设置已选择数据
		setSelDataResult(formdata, dsmaindata, djmxdata) {
			this.globalDsv.sel_formdata = formdata
			this.globalDsv.sel_mainds = dsmaindata
			this.globalDsv.sel_djmxds = djmxdata
			// console.log(this.globalDsv);
			this.dialogVisible = false;
		},
		//获取选择器中的数据
		getSelDataResult() {
			return this.globalDsv;
		},
		mysetFormData(data) {
			this.$refs.vFormRef.setFormData(data)
			this.dialogVisible = false;
		},
		closeDialog(res) {
			if (res) {
				if (this.$refs.vFormRef.globalDsv.okFun) {
					//this.$message.success("正在加载列表数据，请稍后……")
					this.$refs.vFormRef.globalDsv.okFun(res);
				}
			}
			else {
				if (this.$refs.vFormRef.globalDsv.okFun) {
					//this.$message.success("正在加载列表数据，请稍后……")
					this.$refs.vFormRef.globalDsv.okFun(null);
				}
			}
			this.dialogVisible = false;
		},
		PrintDesignPage(row) {
			let routerData = this.$router.resolve({ path: '/printData', query: { row: JSON.stringify(row) } })
			window.open(routerData.href, '_blank')
		},
		close() {
			// console.log(this.pathlog);
			Bus.$emit("Nclearlive", this.pathlog);
			this.Mxloader = false
			this.$refs.vFormRefdilog.setFormJson()
			this.$refs.vFormRefdilog.setFormData()
			setTimeout(() => {
				this.Mxloader = true
			}, 500);
			if (this.reloadMx) {
				this.reload()
			}

		},
		openDialog(formid, key, type) {

			this.pathlog = '/public/index/' + formid
			this.cptyip = formid
			window.localStorage.setItem('formid', this.cptyip)
			//页面关闭刷新刷新
			if (type == true) {
				this.reloadMx = true
			}
			this.dialogVisible = true
			var objPage1 = this;
			this.$refs.sel_el.$nextTick(() => {
				this.fetchData(formid).then(res => {
					if (res.code == 200) {
						this.$refs.vFormRefdilog.setFormJson(res.result.contentData)
						this.formData.con = key
						this.$refs.vFormRefdilog.setFormData(this.formData)
						if (!this.myglobalDsv.parentEL) {
							this.myglobalDsv.parentEL = this
						}

						if (this.globalDsv) {
							this.$refs.vFormRefdilog.globalDsv = this.globalDsv
						}

						this.$nextTick(() => {
							this.renderObject1 = this.$refs.vFormRefdilog;
							this.$refs.vFormRefdilog.addEC('myEC', objPage1)
							// this.Mxloader = true
						})

					}
				})
			})
		},
		detailsPage(formid, filterData) {
			this.pathlog = '/public/index/' + formid
			this.cptyip = formid
			this.detailsdialogVisible = true
			this.loader = false
			var objPage1 = this;
			this.dialTitle = '详情'
			this.fetchData(formid).then(res => {
				if (res.code == 200) {
					this.detailsFormdata = JSON.parse(res.result.contentData)
					this.filterData = filterData
					setTimeout(() => {
						this.loader = true
					}, 1);
				}
			})
		},
		copyid() {
			this.$copyText(this.cptyip).then(res => {
				this.$message.success(this.cptyip + '复制成功!')
			}).catch(err => {

			})
		},
		newOpenDialog(formid, filterData, okFun) {
			this.pathlog = '/public/index/' + formid
			this.cptyip = formid
			// this.$copyText(formid).then(res => {
			// }).catch(err => {			
			// })
			this.dialogVisible = true
			var objPage1 = this;
			this.loader = false
			setTimeout(() => {
				this.loader = true
			}, 1);
			// this.$refs.sel_el.$nextTick(() => {
			this.fetchData(formid).then(res => {
				this.globalDsv.filterData = filterData;//界面上传递的数据
				this.globalDsv.okFun = okFun;//保存后的回调函数
				this.$refs.vFormRefdilog.globalDsv = this.globalDsv
				this.$refs.vFormRefdilog.setFormJson(res.result.contentData)
				//this.$refs.vFormRefdilog.setFormData(filterData) 
				if (!this.myglobalDsv.parentEL) {
					this.myglobalDsv.parentEL = this
				}
				this.$nextTick(() => {
					this.renderObject1 = this.$refs.vFormRefdilog;
					this.$refs.vFormRefdilog.addEC('myEC', objPage1)
				})
			})
			// })

		},
		//打印预览
		OpenPrintPreview(id, obj, typed) {
			// debugger
			let printData = null;
			let template = null;
			let NX
			if (typed.type == 1) {
				sysRpts.newget({ formId: id, rfType: typed.type, FaName: typed.FaName, pagecode: 'Get_RptByRfType' }).then((response) => {

					if (response.result.entity) {
						NX = JSON.parse(response.result.entity)

					}
					if (obj) {
						printData = obj;
					} else {
						printData = NX.printData
					}
					if (response.result && response.result.title) {
						printData.forEach(x => {
							x.title = response.result.title
						})
					}
					template = NX.template
					hiprint.init({
						providers: [new defaultElementTypeProvider()],
					});
					// 创建模板对象
					this.hiprintTemplate = new hiprint.PrintTemplate({
						// "初始模板 json"
						template: template,
						settingContainer: "#PrintElementOptionSetting",
					});
					this.hiprintTemplate.design("#hiprint-printTemplate");
					// 如果你只想打印, 那么 创建模板 对象 参数只需要 "初始模板 json" 然后调用 print/print2 即可
					console.log('打印数据', printData);
					this.hiprintTemplate.print(printData)
					// 浏览器打印
					// console.log('hiprint', hiprint)
					hiprint.print({
						templates: [
							{ template: this.hiprintTemplate, data: printData },
						],
						options: { printer: "", landscape: true },
					})
				})
			} else {
				sysRpts.get({ fromid: id }).then((response) => {
					let NX
					if (response.result && response.result.entity) {
						NX = JSON.parse(response.result.entity)
					}
					if (obj) {
						printData = obj;
					} else {
						printData = NX.printData
					}
					template = NX.template
					hiprint.init({
						providers: [new defaultElementTypeProvider()],
					});
					// 创建模板对象
					this.hiprintTemplate = new hiprint.PrintTemplate({
						// "初始模板 json"
						template: template,
						settingContainer: "#PrintElementOptionSetting",
						// paginationContainer: ".hiprint-printPagination",
					});
					this.hiprintTemplate.design("#hiprint-printTemplate");
					// 如果你只想打印, 那么 创建模板 对象 参数只需要 "初始模板 json" 然后调用 print/print2 即可
					console.log(printData);
					// this.hiprintTemplate.print(printData)

					// 浏览器打印
					hiprint.print({
						templates: [
							{ template: this.hiprintTemplate, data: printData },
						],
						options: { printer: "", landscape: true },
					});
				})
			}
		},
		newOpenPrintPreview(id, obj, typed) {
			// console.log('obj', obj, type);
			sysRpts.get({ fromid: id }).then((response) => {
				response.result.tableDT = JSON.stringify(obj)
				if (typed == '直接打印') {
					response.result.typed = 1
				}
				let routerData = this.$router.resolve({ path: '/printData', query: { row: JSON.stringify(response.result) } })
				window.open(routerData.href, '_blank')
			})


		},
		//直接打印
		OpenPrintPage(id, obj, typed) {
			this.updateObj = typed.params
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});

			this.fromid = id
			this.fromobj = obj
			this.fromotype = typed
			this.FaName = typed.FaName
			console.log("http://" + localStorage.getItem('Ip') + ":17521")
			// hiprint.hiwebSocket.setHost("http://" + localStorage.getItem('Ip') +":17521" );
			// hiprint.hiwebSocket.setHost("http://192.168.32.111:12108", "vue-plugin-hiprint")
			hiprint.hiwebSocket.setHost("http://localhost:17521")
			var printip = ''
			// 查看是否 已连接 "直接打印客户端"
			hiprint.getAddress("mac", (data) => {
				console.log('mac，ip', data);
				printip = data
			});
			hiprint.getAddress("ip", (data) => {
				console.log('ip', data);
				printip = data
			});
			// 
			hiprint.refreshPrinterList((list) => {
				console.log(list);
				this.printselect = list
				this.printselect.forEach(x => {
					if (x.isDefault) {
						this.printselectvalue = x.name
					}
				})
			});
			setTimeout(() => {
				console.log('查看是否 已连接 "直接打印客户端', hiprint.hiwebSocket.opened);
				// console.log(hiprint.hiwebSocket.opened);
				if (hiprint.hiwebSocket.opened) {
					loading.close();
					this.PritndialogVisible = true

				} else {

					this.$alert(`连接【${hiprint.hiwebSocket.host}】失败！！ <a style:"color:red" href="https://wwk.lanzouq.com/iAt2V1gv6oti" target="_blank"><strong> <i>点击下载，密码:ow123</i> </strong>     </a>   如果已有插件请点击   <a href="hiprint://" target="_blank" style:"color:red"><strong> <i> 运  行</i> </strong> </a>`, '客户端未连接', {
						dangerouslyUseHTMLString: true
					});
					loading.close();
				}
			}, 2100)
		},
		Pritenasd(id, obj, typed) {
			this.updateObj = typed.params
			// debugger
			// console.log(id, obj, typed);
			let printData = null;
			let template = null;

			if (typed.type == 1) {

				sysRpts.newget({ fromid: id, rfType: typed.type, FaName: typed.FaName, pagecode: 'Get_RptByRfType' }).then((response) => {
					let NX = ''
					if (response.result && response.result.entity) {
						NX = JSON.parse(response.result.entity)
					}

					if (obj) {
						printData = obj;
					} else {
						printData = NX.printData
					}
					template = NX.template
					if (response.result && response.result.title) {
						// printData[0].title = response.result.title
						printData.forEach(x => {
							x.title = response.result.title
						})
					}

					hiprint.init({
						providers: [new defaultElementTypeProvider()],
					});
					// 创建模板对象
					this.hiprintTemplate = new hiprint.PrintTemplate({
						// "初始模板 json"
						template: template,
						settingContainer: "#PrintElementOptionSetting",
						// paginationContainer: ".hiprint-printPagination",
					});
					this.hiprintTemplate.design("#hiprint-printTemplate");
					// 如果你只想打印, 那么 创建模板 对象 参数只需要 "初始模板 json" 然后调用 print/print2 即可

					if (hiprint.hiwebSocket.opened) {
						// 直接打印
						hiprint.print2(
							{
								templates: [
									{ template: this.hiprintTemplate, data: printData, options: {} },

								],
								options: { printer: this.printselectvalue, landscape: false },
							},
							{
								// 将覆盖面板偏移设置
								leftOffset: -10, // 左偏移
								topOffset: -10// 上偏移
							},
							function (data) {
								console.log("printSuccess");
							},
							function (e) {
								console.log("printError");
							}
						);
						console.log('打印数据', printData);
						this.PritndialogVisible = false
						// console.log('window.globalReqestUtil.Update(this.updateObj)',this.updateObj)
						if (this.updateObj) {
							window.globalReqestUtil.Update(this.updateObj)
						}

						// hiprint.on('printSuccess', function (data) {
						// 	this.$message.success('打印成功！')
						// 	this.PritndialogVisible = false
						// })
						// hiprint.on('printError', function (data) {
						// 	this.$message.success('打印失败！')
						// 	this.PritndialogVisible = false
						// })
					}


				})
			} else {
				sysRpts.get({ fromid: id }).then((response) => {
					let NX = JSON.parse(response.result.entity)
					if (obj) {
						printData = obj;
					} else {
						printData = NX.printData
					}
					template = NX.template
					hiprint.init({
						providers: [new defaultElementTypeProvider()],
					});
					// 创建模板对象
					this.hiprintTemplate = new hiprint.PrintTemplate({
						// "初始模板 json"
						template: template,
						settingContainer: "#PrintElementOptionSetting",
						// paginationContainer: ".hiprint-printPagination",
					});
					this.hiprintTemplate.design("#hiprint-printTemplate");
					// 如果你只想打印, 那么 创建模板 对象 参数只需要 "初始模板 json" 然后调用 print/print2 即可
					if (hiprint.hiwebSocket.opened) {
						// 直接打印
						hiprint.print2(
							{
								templates: [
									{ template: this.hiprintTemplate, data: printData, options: {} },

								],
								options: { printer: this.printselectvalue, landscape: false },
							},
							function (data) {
								console.log("printSuccess");
							},
							function (e) {
								console.log("printError");
							}
						);
						hiprint.on('printSuccess', function (data) {
							this.$message.success('打印成功！')
							this.PritndialogVisible = false
						})
						hiprint.on('printError', function (data) {
							this.$message.success('打印失败！')
							this.PritndialogVisible = false
						})
					}


				})
			}
		},
		openImgDialog(url) {
			if (!this.$viewerApi) {
				this.$message.warning('图片预览组件正在加载，请稍后重试')
				return
			}
			var ss = []
			ss.push(url)
			this.$viewerApi({
				images: ss,
			})
			// this.$refs.ImgVue.show(url)
		},
		cancel: function () {
			this.$confirm('确认关闭？')
				.then(() => {
					if (this.globalDsv.filterData) {
						this.globalDsv.filterData = null;
					}
					this.dialogVisible = false
					// done();
				})
				.catch(() => { });
		},
		showopen(id) {
			this.loaderTable(id)
		},
		loaderTable(id) {
			window.globalConstUtil.setGlobal({
				x_token: getMaoToken.getToken(),
				api_url: process.env.VUE_APP_BASE_API,
				params: { //获取表单列表参数
					orgId: "",
					page: 1,
					limit: 200
				},
				contentType: 'application/x-www-form-urlencoded',
				formId: this.$route.meta.formId || id
			})
			this.fetchData(this.$route.meta.formId || id).then(res => {
				var objPage = this;

				this.$refs.vFormRef.setFormJson(res.result.contentData)
				this.$nextTick(() => {
					this.$refs.vFormRef.addEC('myEC', objPage)
					this.globalDsv.parentEL = this
					this.$refs.vFormRef.globalDsv = this.globalDsv
				})
			})
			this.renderObject2 = this.$refs.vFormRefdilog;
		}

	},

}
</script>


<style scoped lang="less">
.header {
	text-align: right;
	background-color: #fff;
	padding: 0px 20px;
	border-radius: 10px;
	margin-bottom: -20px;
}

.body {
	height: 100vh !important;
}
</style>